import { NgModule } from '@angular/core';
import { FilterPipe } from './filter/filter';
import { SafePipe } from './safe/safe';
@NgModule({
	declarations: [FilterPipe,
    SafePipe],
	imports: [],
	exports: [FilterPipe,
    SafePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts